module.exports = {
  "icon-font": {
    "color": "#666666"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-642b868b!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-icon/index.vue
// module id = 177
// module chunks = 0 1